export const permissionTree = [
    {
        key: 'admin_view',
        title: 'Admin View',
        permissions: [1],
        children: [
            {
                key: 'user', title: 'User Management', permissions: [1, 2, 3]
            },
            {
                key: 'profile', title: 'Profile Management', permissions: [1, 2, 3]
            },
            { key: 'company', title: 'Company Management', permissions: [1, 2, 3] },
            {
                key: 'facility', title: 'Facility Management', permissions: [1, 2, 3]
            },
            {
                key: 'admin_template_menu', title: 'Template', permissions: [1], children: [
                    { key: 'equipmentCategory', title: 'Equipment Category', permissions: [1, 2, 3] },
                    { key: 'facilityCategory', title: 'Facility Category', permissions: [1, 2, 3] },
                    { key: 'serviceCategory', title: 'Service Category', permissions: [1, 2, 3] },
                    { key: 'functionform', title: 'Forms', permissions: [1, 2, 3] },
                ]
            },
            { key: 'admin_settings_menu', title: 'Settings', permissions: [1, 2] },
            {
                key: 'certify_request_menu', title: 'CertifyRequest', permissions: [1, 2, 3]
            },
            { key: 'admin_benchmark_menu', title: 'Benchmark', permissions: [1, 3] },
        ]
    },
    {
        key: 'facility_view',
        title: 'Facility View',
        permissions: [1],
        children: [
            {
                key: 'dashboard_menu',
                title: 'Dashboard',
                permissions: [1]
            },
            {
                key: 'utility_menu',
                title: 'Utility Data',
                permissions: [1],
                children: [
                    { key: 'summary_menu', title: 'Summary', permissions: [1] },
                    { key: 'electricity', title: 'Electricity', permissions: [1, 2, 3] },
                    { key: 'gas', title: 'Gas', permissions: [1, 2, 3] },
                    { key: 'water', title: 'Water', permissions: [1, 2, 3] },
                    {
                        key: 'savings_menu', title: 'Savings', permissions: [1], children: [
                            { key: 'scenario', title: 'Scenario', permissions: [1, 2, 3] },
                        ]
                    },
                    { key: 'certify_menu', title: 'Certify', permissions: [1, 2] },
                ]
            },
            {
                key: 'benchmark', title: 'Benchmark', permissions: [1],
                children: [
                    { key: 'internal_benchmark', title: 'Inter-company Benchmark', permissions: [1] },
                    { key: 'all_benchmark', title: 'All Facility Benchmark', permissions: [1] },
                    { key: 'national_benchmark', title: 'National Benchmark', permissions: [1] },
                ]
            },
            {
                key: 'workorder_folder_menu',
                title: 'Work Order',
                permissions: [1],
                children: [
                    { key: 'workorder', title: 'Work Order', permissions: [1, 2, 3] },
                    { key: 'serviceRequest', title: 'Service Request', permissions: [1, 2, 3] },
                    { key: 'contract', title: 'Contract', permissions: [1, 2, 3] },
                    { key: 'facility_contract', title: 'Facility Contract Companies', permissions: [1, 2, 3] },
                ]
            },
            {
                key: 'equipment_folder_menu',
                title: 'Equipment Management',
                permissions: [1],
                children: [
                    { key: 'equipment', title: 'Equipment', permissions: [1, 2, 3] },
                    { key: 'functiontesting', title: 'Function Testing', permissions: [1, 2, 3] },
                    { key: 'pm_plan', title: 'Preventive Maintenance', permissions: [1, 2, 3] },
                ]
            },
            // { key: 'project', title: 'Project Management' },
            { key: 'log', title: 'System Logs', permissions: [1] },
            { key: 'customreport', title: 'Custom Reports', permissions: [1, 2, 3] },
            { key: 'filemanage', title: 'File Management', permissions: [1, 2, 3] },
            { key: 'facility_ai_chat', title: 'AI Assistant', permissions: [1] },
        ]
    },
    {
        key: 'portfolio_view',
        title: 'Portfolio View',
        permissions: [1],
        children: [
            { key: 'portfolio_dashboard_menu', title: 'Portfolio Dashboard', permissions: [1] },
            { key: 'serviceRequest', title: 'Service Request', permissions: [1, 2, 3] },
            { key: 'contract', title: 'Contract', permissions: [1, 2, 3] },
        ]
    }
];
